import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import axios from 'axios';
import parse from "html-react-parser";
import { Link, useNavigate } from "react-router-dom";
import { variables } from "./Variables.js";

export default function MatchHomePage() {

  const jsonUrl = variables.basename_url + "updates/index/Athlethixnet_HomeEn_Matches.json";
  const [isLoading, setNisLoading] = useState(false);
  const navigate = useNavigate();
  const usenavigate = useNavigate();

  const [Match_HomePage, setMatch_HomePage] = React.useState([]);
  const [Match_HomePageWithResult, setMatch_HomePageWithResult] = React.useState([]);

  async function refda() {
    Get_Data_FMostViewed();
  };

  async function Get_Data_FMostViewed() {

    Match_HomePage.splice(0);  // to clear All data in your page
    Match_HomePageWithResult.splice(0);

    setNisLoading(true);

    axios.get(jsonUrl)
      .then(function (response) {
        setNisLoading(false);

        const data = response.data;
        const Match_HomePage = [];
        const Match_HomePageWithResult = [];

        // Group by date (trim just in case)
        const groupedByDate = {};
        data.forEach(item => {
          const date = (item.SM_game_date_time || "").trim().split(" ")[0];
          if (!groupedByDate[date]) groupedByDate[date] = [];
          groupedByDate[date].push(item);
        });

        // Sort dates (latest → oldest)
        const sortedDates = Object.keys(groupedByDate)
          .sort((a, b) => {
            const [da, ma, ya] = a.split("-").map(Number);
            const [db, mb, yb] = b.split("-").map(Number);
            return new Date(yb, mb - 1, db) - new Date(ya, ma - 1, da);
          });

        // Take 2 matches per date (max 6), Favourate first
        const filtered = sortedDates.flatMap(date => {
          const matchesForDay = groupedByDate[date]
            .sort((a, b) => Number(b.Favourate) - Number(a.Favourate))
            .slice(0, 2);
          return matchesForDay;
        }).slice(0, 6);

        // Build the output arrays
        filtered.forEach(item => {
          const dateTime = item.SM_game_date_time || "";

          // يفصل التاريخ عن الوقت
          const [datePart, timePart] = dateTime.split("T");

          const Day = datePart || "";
          const Time1 = timePart ? timePart.slice(0, 5) : ""; // HH:MM


          const matchObj = {
            id: item.SM_id || Math.random(),
            fav: Number(item.Favourate) || 0,
            SLT_name_en: item.SLT_name_en?.trim() || "",
            SLT_Logo: item.SLT_Logo,
            Day,
            Time1,
            Team1: item.Team1,
            Team2: item.Team2,
            ST_logo: item.ST_logo,
            ST_logo1: item.ST_logo1,
            SM_score1: item.SM_score1,
            SM_score2: item.SM_score2,
          };
          console.log("Match Object:", matchObj);

          Match_HomePageWithResult.push(matchObj);
        });

        setMatch_HomePage(Match_HomePage);
        setMatch_HomePageWithResult([...Match_HomePageWithResult]);

      })
      .catch(function (error) {
        console.error("Error fetching data:", error);
        setNisLoading(false);
      });

  }

  useEffect(() => {
    setNisLoading(true);
    refda();
  }, []);

  return (
    <>
      <div className="upcoming-matches-post mt-35 most-view-box mt-2 border ">
        <div className="section-title d-flex justify-content-between align-items-center">
          <h3 className="title">Latest Matches</h3>
          <a href="FootballMatches"> SEE ALL</a>
        </div>
        <div className="upcoming-matches-post-items">
          <div className="container">
            {Match_HomePageWithResult.map(da => (
              <div key={da.id} className="match-card d-flex align-items-center justify-content-between p-3 border-0 rounded mb-3">

                {/* Team 1 */}
                <div className="team d-flex align-items-center justify-content-start flex-shrink-0" style={{ width: '140px' }}>
                  <img src={variables.MatchesImg + da.ST_logo} className="team-logo rounded-circle me-2" alt={da.Team1} />
                  <span className="team-name text-truncate" style={{ width: '100px', textAlign: 'left', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {da.Team1}
                  </span>
                </div>

                {/* Date or Score */}
                <div className="match-info text-center flex-shrink-0" style={{ width: '100px' }}>
                  {da.SM_score1 === '' || da.SM_score1 === '-1' || da.SM_score1 === '-' ? (
                    <>
                      <span className="match-time d-block" style={{ fontSize: '13px' }}>{da.Time1}</span>
                      <span className="match-date d-block" style={{ fontSize: '12px' }}>{da.Day}</span>
                    </>
                  ) : (
                    <>
                      <span className="match-score d-block" style={{ fontSize: '14px' }}>
                        {da.SM_score1} <span className="score-separator">-</span> {da.SM_score2}
                      </span>
                      <span className="match-date d-block" style={{ fontSize: '11px' }}>{da.Day}</span>
                      <span className="match-time d-block" style={{ fontSize: '11px', color: '#6c757d', fontWeight: 600 }}>
                        {da.Time1}
                      </span>
                    </>
                  )}
                </div>

                {/* Team 2 */}
                <div className="team d-flex align-items-center justify-content-end flex-shrink-0" style={{ width: '140px' }}>
                  <img src={variables.MatchesImg + da.ST_logo1} className="team-logo rounded-circle ms-2" alt={da.Team2} />

                  <span className="team-name text-truncate" style={{ width: '100px', textAlign: 'left', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {da.Team2}
                  </span>
                </div>

              </div>
            ))}
          </div>
        </div>



      </div>
    </>
  );
}
